import { render, staticRenderFns } from "./StrategiesOptimization.vue?vue&type=template&id=626cbbfe&scoped=true&"
import script from "./StrategiesOptimization.vue?vue&type=script&lang=js&"
export * from "./StrategiesOptimization.vue?vue&type=script&lang=js&"
import style0 from "./StrategiesOptimization.vue?vue&type=style&index=0&id=626cbbfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626cbbfe",
  null
  
)

export default component.exports